

interface OnboardingProgressProps {
  currentStep: number;
  totalSteps: number;
}

const OnboardingProgress = ({ currentStep, totalSteps }: OnboardingProgressProps) => {
  return (
    <div className="mb-8 animate-slide-up">
      <div className="flex justify-between text-xs font-medium text-white/70 mb-2">
        <span>Step {currentStep + 1} of {totalSteps}</span>
        <span>{Math.round(((currentStep + 1) / totalSteps) * 100)}%</span>
      </div>
      <div className="w-full bg-white/20 rounded-full h-2">
        <div 
          className="bg-gradient-to-r from-purple-500 to-teal-400 h-2 rounded-full transition-all duration-700 ease-out animate-pulse-gentle"
          style={{ width: `${((currentStep + 1) / totalSteps) * 100}%` }}
        ></div>
      </div>
    </div>
  );
};

export default OnboardingProgress;

